import React, { useContext, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import Menu from "../components/Menu";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { TranslationContext } from "../contexts/TranslationContext";
import API_BASE_URL from "../apiConfig";

const SendMessages = () => {

  const { translations, routes } = useContext(TranslationContext);
  const maxChars = 550;
  const minChars = 20;

  // Validation Schema
  const validationSchema = Yup.object({
    message: Yup.string()
      .min(minChars, `${translations.msgMin} ${minChars} ${translations.characters} minimum`)
      .max(maxChars, `${translations.msgMax} ${maxChars} ${translations.characters}`)
      .required(translations.msgReq),
  });

  const handleInputChange = (e) => {
    const value = e.target.value;

    if (value.length > maxChars) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "warning",
        title: `${translations.charactersWarn} ${maxChars} ${translations.characters} maximum`,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    } else {
      formik.handleChange(e);
    }
  };
  // Trigger SweetAlert2 Toast on Validation Error
  const handleValidationError = () => {
    if (formik.touched.message && formik.errors.message) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: formik.errors.message,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    }
  };
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      message: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true); // Set loading state to true

      try {
        const token = localStorage.getItem("token"); // Retrieve the token
        if (!token) {
          Swal.fire("Error", "No token found. Please log in again.", "error");
          navigate("/se-connecter");
          return;
        }

        // API request to send the message
        const response = await fetch(`${API_BASE_URL}/api/chat/send`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ message: values.message }),
        });

        if (response.ok) {
          Swal.fire({
            toast: true,
            position: "top-end",
            title: translations.msgSend,
            icon: "success",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          navigate(routes.chatroom);
        } else {
          const errorData = await response.json();
          Swal.fire("Error", errorData.message || "Échec de l'envoi du message", "error");
        }
      } catch (error) {
        console.error("Error sending message:", error);
        Swal.fire("Error", "An unexpected error occurred. Please try again.", "error");
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <>
      <Helmet>
        <title>{translations.sendOpinions} - O.A.V.L.I.T.E</title>
      </Helmet>
      <div className="navbar-header container-fluid px-3 pt-2 mb-5">
        <div className="w-100"></div>
        <div className="text-center logo-wrapper pt-3">
          <Link to="/" className="logo-link">
            <img
              src="../images/oavlite-black.png"
              className="img-fluid mx-auto text-center d-block d-logo mb-3"
              alt="oavlite"
            />
          </Link>
          <p className="mb-2 fw-500 tagline__1">
            {translations.taglineV1}
          </p>

        </div>
        <Menu />
      </div>
      <div className="login-wrapper message-wrapper position-relative">
        <div className="container-xxl px-5">
          <div className="center-content">
            <p className="text-center mb-md-5 mb-4 fw-500 opinionTagline">{translations.opinionTagline1}</p>
            <form onSubmit={formik.handleSubmit}>
              <div className="row">
                <div className="col-9 pe-1">
                  <div className="message-box">
                    <textarea
                      name="message"
                      className={`form-control mb-2 message-area ${formik.touched.message && formik.errors.message ? "is-invalid" : ""}`}
                      placeholder={translations.msgPlaceholder}
                      value={formik.values.message}
                      onChange={handleInputChange}
                      onBlur={(e) => {
                        formik.handleBlur(e);
                        handleValidationError();
                      }}

                    ></textarea>
                  </div>
                </div>
                <div className="col-3 col-lg-2 col-md-2 d-flex">
                  <button
                    type="submit"
                    className="btn btn-light bgprimary border-0 text-white fw-bold w-100 mb-2 send-msg"
                    style={{ height: "250px" }}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    ) : (
                      translations.send
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <footer className="text-center d-footer">
        <p>
          <Link className="color-primary" to={routes.legalNotices}>
            CGU
          </Link>
        </p>
      </footer>
    </>
  );
};

export default SendMessages;
